const GAIN_START = 0.3;
const GAIN_END = 0.0001;

const startOscillator = (audioContext, frequency, durationMs, startOffsetSeconds = 0) => {
  if (!audioContext) return;

  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  const startTime = audioContext.currentTime + startOffsetSeconds;
  const durationSeconds = durationMs / 1000;

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startTime);

  gainNode.gain.setValueAtTime(GAIN_START, startTime);
  const rampEndTime = durationSeconds > 0 ? startTime + durationSeconds : startTime + 0.05;
  gainNode.gain.exponentialRampToValueAtTime(GAIN_END, rampEndTime);

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.start(startTime);
  oscillator.stop(startTime + durationSeconds);
};

export const playBeep = (audioContext, frequency, durationMs) => {
  startOscillator(audioContext, frequency, durationMs);
};

export const playCountdown = (audioContext) => {
  if (!audioContext) return;

  const steps = [
    { frequency: 600, duration: 200, delaySeconds: 0 },
    { frequency: 800, duration: 200, delaySeconds: 1 },
    { frequency: 1000, duration: 200, delaySeconds: 2 },
    { frequency: 1000, duration: 2000, delaySeconds: 3 },
  ];

  steps.forEach(({ frequency, duration, delaySeconds }) => {
    startOscillator(audioContext, frequency, duration, delaySeconds);
  });
};

export const playIntervalBeep = (audioContext) => {
  startOscillator(audioContext, 1000, 2000);
};

